"use client";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useGetProductDetailsQuery } from "@/api/AppApi/services/product";
import { Modal } from "@/utils/bootstrap";
import GeneralApiLoader from "@/app/components/lib/loaders/GeneralApiLoader";
// import ProductDetails from "@/app/components/pages-components/product-details-page/ProductDetails";
import useProductPopup from "@/hooks/useProductPopup";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { ProductPreviewTypes } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import dynamic from "next/dynamic";
import SvgModalClose from "@/app/components/lib/SvgModalClose";

interface ContainerProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  isConfigurable: boolean;
}

const ProductDetails = dynamic(
  () =>
    import(
      "@/app/components/pages-components/product-details-page/ProductDetails"
    ),
);
const ProductPopUp: React.FC = () => {
  const { handleClosePopup, popupValue } = useProductPopup();

  const {
    data: productDetailsData,
    isLoading,
    isError,
  } = useGetProductDetailsQuery({
    params: { id: popupValue?.productID },
  });
  const { data } = useGetCompanyQuery();

  const isConfigrableProduct =
    productDetailsData?.result?.is_configurable &&
    productDetailsData.result.preview_type === ProductPreviewTypes.general;
  const isAllowAddConfigutableProductToCart =
    data?.result.theme.components.product
      .allow_add_configurable_product_to_cart;
  const isConfigrablePopup =
    popupValue?.isConfigurable ||
    (isConfigrableProduct && isAllowAddConfigutableProductToCart);
  const product = productDetailsData?.result;
  if (popupValue === null) return null;

  return (
    <Container
      isOpen={!!popupValue}
      onClose={handleClosePopup}
      isConfigurable={!!isConfigrablePopup}
    >
      {isLoading ? (
        <GeneralApiLoader />
      ) : isError ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Not Found
        </div>
      ) : (
        <ProductDetails
          popup={isConfigrablePopup ? "configrable" : "normal"}
          product={product!}
          AttrbuitesInitialValues={popupValue.AttrbuitesInitialValues}
        />
      )}
    </Container>
  );
};
export default ProductPopUp;

const Container: React.FC<ContainerProps> = ({
  children,
  isOpen,
  onClose,
  isConfigurable,
}) => {
  const mobile = useIsMobile();
  const mCLass = mobile ? "w-100" : "product-popup-container";
  const modalClassName = mobile
    ? "modal-as-swipeable-drawer drawer up-align"
    : "";
  const dialogClassName = !mobile
    ? "messagebox-dialog"
    : "vw-100 navbar navbar-expand navbar-light fixed-bottom dialog-swipeable-drawer with-padding-top product-popup-dialog product-popup-dialog";
  const contentClassName = mobile
    ? "pop-up-modal-content-mobile"
    : "pop-up-modal-contents";
  return (
    <Modal
      centered={!mobile}
      show={isOpen}
      onHide={onClose}
      className={modalClassName}
      dialogClassName={dialogClassName}
      contentClassName={contentClassName}
    >
      <div
        className={mCLass}
        style={
          isConfigurable
            ? {
                width: 550,
                maxWidth: "100%",
                height: "fit-content",
                maxHeight: "77vh",
                minHeight: "45vh",
              }
            : {}
        }
      >
        <div style={{ position: "absolute", top: 16, left: 16, zIndex: 1000 }}>
          <SvgModalClose onClick={onClose} />
        </div>

        {children}
      </div>
    </Modal>
  );
};
